<template>
    <div class='tabs-container tabs-container-cp'>
            <div @click.prevent="setActiveTabName('info')" class="tab tab-cp" v-bind:class="{ 'is-active' : displayContents(activeTabName, 'info')}" id="info-tab-cp">
              {{ activeInfoDisplay}}
            </div>
            <div v-if="showViewRequests" @click.prevent="setActiveTabName('view-requests')" class="tab tab-cp" v-bind:class="{ 'is-active' : displayContents(activeTabName, 'view-requests')}">
              Search Jobs
            </div>
        <div class='tab-msg tab-error main-error-msg'></div>
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            // Managing tabs
            //activeTabName: '',
            // tabs: [
            //   { 
            //     name: 'info',
            //     displayName: VueStore.getters.nav.getActiveInfoDisplay,
            //   },
            //   { 
            //     name: 'view-requests',
            //     displayName: 'View Requests',
            //   },
            // ],
        }
    },

    computed: {

        ...mapGetters('nav', {
            activeInfoDisplay: 'getActiveInfoDisplay'
        }),

        ...mapState('nav', {
            activeTabName: state => state.activeRequestsTab,
            showViewRequests: state => state.showViewRequests
        }),

    },

    methods: {
        setActiveTabName(name) {
            //this.activeTabName = name;
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeRequestsTab',
                    value: name
                }
            )

            // workaround to get export buttons to work as DT needs to reload first
            if(name === 'view-requests'){
                VueStore.dispatch('datatable/resetDatatable');
            }
        },

        displayContents(activeTabName, name) {
            return activeTabName === name;
        },
    },

    created(){
    },

    mounted(){
        // Check local storage for active tab 
        if(typeof sessionStorage.getItem("ACTIVE-REQUESTS-TAB") !== 'undefined' && sessionStorage.getItem("ACTIVE-REQUESTS-TAB") !== null){
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeRequestsTab',
                    value: sessionStorage.getItem("ACTIVE-REQUESTS-TAB")
                }
            )
        } else {
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeRequestsTab',
                    value: 'info'
                }
            )
        }

        // Check local storage for active request info sub tab
        if(typeof sessionStorage.getItem("ACTIVE-REQUESTS-INFO-TAB") !== 'undefined' && sessionStorage.getItem("ACTIVE-REQUESTS-INFO-TAB") !== null){
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeRequestInfoTab',
                    value: sessionStorage.getItem("ACTIVE-REQUESTS-INFO-TAB")
                }
            )
        } else {
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeRequestInfoTab',
                    value: 'details'
                }
            )
        }

        // Check local storage for active request info sub tab
        if(typeof sessionStorage.getItem("ACTIVE-INFO-DISPLAY") !== 'undefined' && sessionStorage.getItem("ACTIVE-INFO-DISPLAY") !== null){
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeInfoDisplay',
                    value: sessionStorage.getItem("ACTIVE-INFO-DISPLAY")
                }
            )
        } else {
            VueStore.dispatch('nav/setVariables', 
                {
                    key: 'activeInfoDisplay',
                    value: '--'
                }
            )
        }

        $('#info-tab-cp').click();
    }
}
</script>